const configuredBaseUrl = (process.env.REACT_APP_API_BASE_URL || "").trim();
const isLocalHost =
  typeof window !== "undefined" &&
  (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1");

// Prevent production clients from falling back to localhost when env vars are missing.
const fallbackBaseUrl = isLocalHost
  ? "http://localhost:5000"
  : "https://rungdo-live-backed.vercel.app";

export const API_BASE_URL = (configuredBaseUrl || fallbackBaseUrl).replace(/\/+$/, "");
